import React from 'react';
import {useGetProductTemplateInfo} from "../../../api/api-hooks/product-templates-hooks";

interface IProductTemplateTitleProps {
    value: number | null ;
}

export default function ProductTemplateTitle(props: IProductTemplateTitleProps) {
    const query = useGetProductTemplateInfo(props.value, {enabled: props.value != null})

    const loading = query.isLoading;

    const displayName = query.data?.displayName || "-";

    return <>
        { props.value == null
            ? "Product template not selected"

            : <>
                { loading && "Loading..." }

                { query.isError && "Error!" }

                { !query.isLoading && !query.isError && displayName }
            </>
        }

    </>
}